import request from '@/common/request'
// import file from '@/common/fileDownload'
/**
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
 */
export default {
    // 审批
    audit: (data) => {
        return request({
            url: '/v1/task/audit',
            method: 'post',
            data,
        })
    },
    createTask: (dynaSeg, data, params) => {
        return request({
            url: '/v1/task',
            method: 'post',
            data,
            params
        })
    },
    deleteTask: (dynaSeg, data, params) => {
        return request({
            url: `/v1/task/${dynaSeg.id}`,
            method: 'delete',
            data,
            params
        })
    },
    updateTask: (dynaSeg, data) => {
        return request({
            url: `/v1/task/${dynaSeg.id}`,
            method: 'put',
            data,
        })
    },
    queryTask: params => {
        return request({
            url: '/v1/task',
            method: 'get',
            params
        })
    },
    getOrgPeopleGroupByRole: (dynaSeg) => {
        return request({
            url: `/org/getOrgPeopleGroupByRole/${dynaSeg.orgCode}`,
            method: 'post',
        })
    },
    getLockListByOrgCode: (dynaSeg) => {
        return request({
            url: `/v1/task/getLockListByOrgCode/${dynaSeg.orgCode}`,
            method: 'post',
        })
    },
    getLockListByOrgCodeSUB: (dynaSeg, params) => {
        return request({
            url: `/v1/task/getLockListByOrgCode/SUB/${dynaSeg.orgCode}`,
            method: 'post',
            params
        })
    },
    getKeyListByOrgCode: (dynaSeg) => {
        return request({
            url: `/v1/task/getKeyListByOrgCode/${dynaSeg.orgCode}`,
            method: 'post',
        })
    },
    // 获取机构列表
    getMechanismList: (orgCode) => {
        return request({
            url: `/org/${orgCode}`,
            method: 'get'
        })
    },
    // 获取人员列表
    getrelUserList: (orgId) => {
        return request({
            url: `/user/findUserByOrgId/${orgId}`,
            method: 'get'
        })
    },
    // 获取角色
    getRoleLists: (data) => {
        return request({
            url: '/role/getRoleList',
            method: 'post',
            data
        })
    },
    // 根据岗位角色ID查询用户列表
    findUserByRoleId: (roleId) => {
        return request({
            url: `/user/findUserByRoleId/${roleId}`,
            method: 'get'
        })
    },
    getLockNamesByLockIds: (data) => {
        return request({
            url: '/v1/generalTask/getLockNamesByLockIds',
            method: 'post',
            data
        })
    },
    getKeyNamesByKeyIds: (data) => {
        return request({
            url: '/v1/generalTask/getKeyNamesByKeyIds',
            method: 'post',
            data
        })
    },
    getUserNamesByUserIds: (data) => {
        return request({
            url: '/user/getUserNamesByUserIds',
            method: 'post',
            data
        })
    },
    getDeviceInfoOrgCode: (orgCode) => {
        return request({
            url: `/deviceInfo/devices/${orgCode}`,
            method: 'get'
        })
    },
    // 终止
    changeStatus: (data) => {
        return request({
            url: `/v1/taskManage/changeStatus/${data.id}`,
            method: 'patch',
            data
        })
    }

}



// WEBPACK FOOTER //
// ./src/api/modules/task.js